<template>
    <div class="order-detail-section mg20"
         v-if="order">
        <h3>业绩信息</h3>
        <el-tabs v-model="activeName" style="margin-left: 10px;" :class="[oldOrder?'':activeClass]">
            <el-tab-pane name="new">
                <span slot="label" v-if="oldOrder">新修改</span>
                <div style="margin-left:20px;">总业绩：{{isOrderSensitiveMasked ? '******' : _.round(total_performance_amount, 2) }}元</div>
                <el-table :data="order.user" border style="margin:20px; width:97%">
                    <el-table-column label="业务员" prop="name">
                        <template slot-scope="scope">
                            <div>{{scope.row.name}}<strong v-if="scope.row.is_cooperator == 0"
                                                           style="color:red; font-weight:normal">（负责人）</strong>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="新增业绩额（元）" prop="pfm_amount"></el-table-column>
                    <el-table-column label="续费业绩额（元）" prop="renew_amount"></el-table-column>
                    <el-table-column label="续费完成（元）" prop="finish_amount"></el-table-column>
                    <el-table-column label="新增业绩占比">
                        <template slot-scope="scope">{{calculateRatio(scope.row.pfm_amount, total_performance_amount)}}</template>
                    </el-table-column>
                    <el-table-column label="续费金额占比">
                        <template slot-scope="scope">{{calculateRatio(scope.row.renew_amount, total_renew_amount)}}</template>
                    </el-table-column>
                    <el-table-column label="个人成交金额占比">
                        <template slot-scope="scope">{{calculateCombinedRatio(scope.row, total_performance_amount, total_renew_amount)}}</template>
                    </el-table-column>
                    <el-table-column label="接管人" prop="take_over_name"></el-table-column>
                </el-table>
            </el-tab-pane>
            <el-tab-pane label="旧数据" name="second" v-if="oldOrder">
                <span slot="label" style="color: red;">原来数据</span>
                <div style="margin-left:20px;">总业绩：{{isOrderSensitiveMasked ? '******' : oldTotal_performance_amount }}元</div>
                <el-table :data="oldOrder.user" border style="margin:20px; width:97%">
                    <el-table-column label="业务员" prop="name">
                        <template slot-scope="scope">
                            <div>{{scope.row.name}}<strong v-if="scope.row.is_cooperator == 0"
                                                           style="color:red; font-weight:normal">（负责人）</strong>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="业绩金额（元）" prop="pfm_amount"></el-table-column>
                    <el-table-column v-if="order.type==3" label="续费金额（元）" prop="renew_amount"></el-table-column>
                    <el-table-column label="新增业绩占比">
                        <template slot-scope="scope">{{calculateRatio(scope.row.pfm_amount, oldTotal_performance_amount)}}</template>
                    </el-table-column>
                    <el-table-column v-if="order.type==3" label="续费金额占比">
                        <template slot-scope="scope">{{calculateRatio(scope.row.renew_amount, oldTotal_renew_amount)}}</template>
                    </el-table-column>
                    <el-table-column label="个人成交金额占比">
                        <template slot-scope="scope">{{calculateCombinedRatio(scope.row, oldTotal_performance_amount, oldTotal_renew_amount)}}</template>
                    </el-table-column>
                    <el-table-column label="接管人" prop="take_over_name"></el-table-column>
                </el-table>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<style scoped>
    .no_tab {
        margin-top: -50px;
    }
</style>
<script>
    import {OrderMixin} from "~/services/OrderMixin";

    export default {
        mixins: [OrderMixin],
        props: {
            order: {
                required: true
            },
            oldOrder: {
                required: false
            }
        },
        computed: {
            isOrderSensitiveMasked() {
                return Boolean(this.order && this.order.order_sensitive_masked)
                    || Boolean(this.oldOrder && this.oldOrder.order_sensitive_masked);
            }
        },
        watch: {
            order(v, s) {
                if (this.isOrderSensitiveMasked) {
                    this.resetTotals();
                    return;
                }
                if (this.order) {
                    this.total_performance_amount = _.reduce(this.order['user'], (memo, item) => {
                        return memo + (Number(item.pfm_amount) || 0)
                    }, 0)
                }
                if (this.order) {
                    this.total_renew_amount = _.reduce(this.order['user'], (memo, item) => {
                        return memo + (Number(item.renew_amount) || 0)
                    }, 0)
                }
            },
            oldOrder(v, s) {
                if (this.isOrderSensitiveMasked) {
                    this.resetTotals();
                    return;
                }
                if (this.oldOrder.user) {
                    this.oldTotal_performance_amount = _.reduce(this.oldOrder.user, (memo, item) => {
                        return memo + (Number(item.pfm_amount) || 0)
                    }, 0)
                }
                if (this.oldOrder.user) {
                    this.oldTotal_renew_amount = _.reduce(this.oldOrder.user, (memo, item) => {
                        return memo + (Number(item.renew_amount) || 0)
                    }, 0)
                }
            }
        },
        mounted() {
            let params = {
                fields: 'id,name',
                scenario: 'all-user'
            };

            if (this.order && !this.isOrderSensitiveMasked) {
                this.total_performance_amount = _.reduce(this.order['user'], (memo, item) => {
                    return memo + (Number(item.pfm_amount) || 0)
                }, 0)
                this.total_renew_amount = _.reduce(this.order['user'], (memo, item) => {
                    return memo + (Number(item.renew_amount) || 0)
                }, 0)
            }
        },
        methods: {
            calculateRatio(value, total) {
                if (this.isOrderSensitiveMasked) {
                    return '******';
                }
                const amount = Number(value) || 0;
                const totalAmount = Number(total) || 0;
                return amount && totalAmount ? (amount / totalAmount * 100).toFixed(1) + '%' : '0%';
            },
            calculateCombinedRatio(row, performanceTotal, renewTotal) {
                const amount = (Number(row.pfm_amount) || 0) + (Number(row.renew_amount) || 0);
                return this.calculateRatio(amount, (Number(performanceTotal) || 0) + (Number(renewTotal) || 0));
            },
            resetTotals() {
                this.total_performance_amount = 0;
                this.total_renew_amount = 0;
                this.oldTotal_performance_amount = 0;
                this.oldTotal_renew_amount = 0;
            }
        },
        data() {
            return {
                activeClass: 'no_tab',
                activeName: 'new',
                total_performance_amount: 0,
                total_renew_amount: 0,
                oldTotal_performance_amount: 0,
                oldTotal_renew_amount: 0,
                users: [],
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/views/order/partial/order_performance.vue